export function getThumbnailLink(pdfLink: string): string {
    return pdfLink.replace('.pdf', '_thumb.png');
}

export function convertToCdnUrl(url: string, language: string = 'EN'): string | null {
    try {
        const { searchParams } = new URL(url);
        
        const videoType = searchParams.get('videoType');
        const videoCode = searchParams.get('videoCode');

        if (!videoType || !videoCode) return null;

        const typeMap: Record<string, string> = {
            'lesson': 'lesson_videos',
            'strategy': 'strategy_videos'
        };

        const typeDir = typeMap[videoType] ?? `${videoType}_videos`;

        const gradeMatch = videoCode.match(/(G[^_]+)_/);
        if (!gradeMatch) return null;
        
        const gradeDir = gradeMatch[1].toLowerCase();
        if (language === 'ES') {
            return `https://videocdn.paradigmmath.com/${typeDir}/${gradeDir}/${videoCode}_ES.mp4`;
        }

        return `https://videocdn.paradigmmath.com/${typeDir}/${gradeDir}/${videoCode}.mp4`;
    } catch (e) {
        return null;
    }
}